import Vue from 'vue';
import Router from 'vue-router';
import { isLoggedIn, mustResetPassword, getIsAdmin } from '@/utils/auth';

Vue.use(Router);

const cvePage = (menuId, apiSource) => ({
  component: () => import('@/views/ProjectManage/CveNvd'),
  meta: { menuId, apiSource }
});

const router = new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/views/ProjectManage/Index'),
      redirect: '/home',
      children: [
        {
          path: 'home',
          name: 'home',
          component: () => import('@/views/ProjectManage/Home'),
          meta: { menuId: 'home' }
        },
        {
          path: 'analysis/nvd',
          name: 'analysis-nvd',
          ...cvePage('cve-nvd', 'nvd')
        },
        {
          path: 'analysis/mitre',
          name: 'analysis-mitre',
          ...cvePage('cve-mitre', 'mitre')
        },
        {
          path: 'analysis/cisa',
          name: 'analysis-cisa',
          ...cvePage('cve-cisa', 'cisa')
        },
        {
          path: 'analysis/github',
          name: 'analysis-github',
          ...cvePage('cve-github', 'github')
        },
        {
          path: 'analysis/exploited',
          name: 'analysis-exploited',
          ...cvePage('cve-exploited', 'cve_exploited_db')
        },
        {
          path: 'packages/vulnerability-check',
          name: 'packages-vulnerability-check',
          component: () => import('@/views/ProjectManage/VulnerabilityCheck'),
          meta: { menuId: 'vulnerability-check' }
        },
        {
          path: 'packages/cve-check',
          name: 'packages-cve-check',
          component: () => import('@/views/ProjectManage/CveCheck'),
          meta: { menuId: 'cve-check' }
        },
        {
          path: 'history/batch',
          name: 'history-batch',
          component: () => import('@/views/ProjectManage/BatchHistory'),
          meta: { menuId: 'batch-history' }
        },
        {
          path: 'history/downloads',
          name: 'history-downloads',
          component: () => import('@/views/ProjectManage/DownloadHistory'),
          meta: { menuId: 'download-history' }
        },
        {
          path: 'app/wgmu',
          name: 'app-wgmu',
          component: () => import('@/views/ProjectManage/Wgmu'),
          meta: { menuId: 'app-wgmu' }
        },
        {
          path: 'user/create',
          name: 'user-create',
          component: () => import('@/views/User/CreateUser'),
          meta: { menuId: 'user-create', requiresAdmin: true }
        },
        {
          path: 'user/list',
          name: 'user-list',
          component: () => import('@/views/User/UserList'),
          meta: { menuId: 'user-list', requiresAdmin: true }
        }
      ]
    },
    {
      path: '/intro/wgmu',
      name: 'intro-wgmu',
      component: () => import('@/views/ProjectManage/WgmuIntro'),
      meta: { public: true }
    },
    {
      path: '/user/login',
      name: 'user_login',
      component: () => import('@/views/User/Login')
    },
    {
      path: '/user/reset-password',
      name: 'user_reset_password',
      component: () => import('@/views/User/ResetPassword'),
      meta: { allowWithReset: true }
    },
    {
      path: '/project/manage',
      redirect: '/home'
    },
    {
      path: '/project/star',
      redirect: '/home'
    }
  ]
});

router.beforeEach((to, from, next) => {
  const loggedIn = isLoggedIn();
  const isLoginRoute = to.path === '/user/login';
  const isResetRoute = to.path === '/user/reset-password';
  const isPublicRoute = to.matched.some(record => record.meta && record.meta.public);
  const needsReset = loggedIn && mustResetPassword();

  if (!loggedIn && !isLoginRoute && !isPublicRoute) {
    next({
      path: '/user/login',
      query: { redirect: to.fullPath }
    });
    return;
  }

  if (loggedIn && isLoginRoute) {
    if (needsReset) {
      next({ path: '/user/reset-password', query: { redirect: to.query.redirect || '/home' } });
    } else {
      next(to.query.redirect || '/home');
    }
    return;
  }

  if (needsReset && !isResetRoute && !isPublicRoute) {
    next({
      path: '/user/reset-password',
      query: { redirect: to.fullPath }
    });
    return;
  }

  if (loggedIn && isResetRoute && !needsReset) {
    next(to.query.redirect || '/home');
    return;
  }

  if (to.meta && to.meta.requiresAdmin && !getIsAdmin()) {
    next('/home');
    return;
  }

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js